// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"20":"a8e36daf","149":"f25b3b13","288":"1b79e62a","586":"47257334","722":"0ec22e59"}[chunkId] + ".css";
};